import flag_rus from "../images/flag_rus.gif"
import flag_bel from "../images/flag_bel.gif"
import axios from "axios";

export const yesNo = (data) => data === true ? 'Да' : 'Нет';

export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function createRef() {
    return {current: null};
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export function subtractDays(date, days) {
    date.setDate(date.getDate() + days);

    return date;
}

export function subtractHours(date, hours) {
    date.setHours(date.getHours() + hours);

    return date;
}
export function subtractMinutes(date, minutes) {
    date.setMinutes(date.getMinutes() + minutes);

    return date;
}

export function subtractSeconds(date, seconds) {
    date.setSeconds(date.getSeconds() + seconds);

    return date;
}


export function explodeStrToRows(str, separator) {
    let arr = str.split(separator);
    return arr.map((item, index) =>
        <div key={index}>{item}</div>
    )
}

export function getFlagByAddress(address) {
    if (address.includes('еларус') || address.includes('минск')) {
        return <img className='flag' src={flag_bel} width={30}/>
    } else return <img className='flag' src={flag_rus} width={30}/>
}

export const getFileHandler = async e => {
    let fileId = e.target.getAttribute('fileid');
    await axios.get(`/api/file/download/${fileId}`, {
        responseType: "blob",
    })
        .then(result => {
            console.log(result)
            if (result.status === 200) {
                let contentDisposition = result.headers['content-disposition'];
                let findFileArr = /".*"/.exec(contentDisposition);
                let fileName = findFileArr[0].substring(1, findFileArr[0].length-1);

                const element = document.createElement("a")
                const blob = new Blob([result?.data])
                element.href = URL.createObjectURL(blob)
                element.download = fileName;
                document.body.appendChild(element)
                element.click()

                element.parentNode.removeChild(element);
            } else {
                console.log('error: ' + result )
            }
        })
}

export function checkPermission(userPermissions, checkPerm) {
    return userPermissions.includes(checkPerm);
}

export function checkReExpProductsHaveGroup0708(reExportArr) {
    let sumProducts = 0;
    let isHave = false;

    reExportArr.forEach((item) => {
        // sumProducts += item.product.length;
        item.product.forEach((itemP) => {
            if (itemP.production.value.name.match(/^0[7-8]/)) {
                isHave = true;
            }
        })
    })

    return isHave;
}

